module.exports = __webpack_public_path__ + "img/planning.1520a11f.svg";